import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { login } from '../../services/auth';
import { session } from '../../services/session';
import { FORGOT_PASSWORD, ORDERS } from '../../routes';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    if (session.has('uid')) {
      this.redirectToOrders();
    }
  }

  redirectToOrders() {
    this.props.history.push(ORDERS);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    login(this.state.email, this.state.password)
      .then(() => this.redirectToOrders())
      .catch(message => window.alert(message));
  }

  render() {
    return (
      <div className="card">
        <h1 className="card-header h5">Login</h1>
        <div className="card-body">
          <form onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                value={this.state.email}
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                value={this.state.password}
                onChange={this.handleChange}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary mr-4">
              Login
            </button>
            <Link to={FORGOT_PASSWORD}>Forgot Password?</Link>
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(LoginPage);



// WEBPACK FOOTER //
// ./src/components/auth/LoginPage.js